import { Age, isAge, isProfile, Profile } from "@common";
import React, { useState } from "react";

import { tryToParseStorageKeyValue } from "../util/webStorage";

export interface TestTakerSettings {
  profiles: Array<Profile>;
  age: Age;
  fetchedFromStorage?: boolean;
}

type TestTakerSettingsContextType = [TestTakerSettings, React.Dispatch<any>];

export const TestTakerSettingsContext = React.createContext<TestTakerSettingsContextType>([
  { profiles: [], age: "adult" },
  () => null,
]);

const sanitizeSettings = (profiles: Array<Profile>, age: string) => {
  profiles.filter((a) => isProfile(a));
  age = isAge(age) ? age : "adult";
};

export const TestTakerSettingsProvider: React.FC<{
  children: React.ReactElement;
}> = ({ children }) => {
  const [testTakerSettings, setTestTakerSettings] = useState(() => {
    let profiles = tryToParseStorageKeyValue("profiles");
    let age = tryToParseStorageKeyValue("age", "string");
    let fetchedFromStorage = true;
    if (age === null || profiles === null) {
      profiles = ["general"];
      age = "adult";
      fetchedFromStorage = false;
    }
    sanitizeSettings(profiles, age);
    return {
      profiles: profiles,
      age: age,
      fetchedFromStorage: fetchedFromStorage,
    };
  });

  return (
    <TestTakerSettingsContext.Provider value={[testTakerSettings, setTestTakerSettings]}>
      {children}
    </TestTakerSettingsContext.Provider>
  );
};
